import { jsx as _jsx } from "react/jsx-runtime";
import { AggregationLevel } from '../../types';
import Select from '../Select';
import SelectItem from '../SelectItem';
const AggregationLevelFilter = (props) => {
    const { selected, onSelect, className, disableOneMinuteResolution } = props;
    let aggregateLvlKeys = Object.keys(AggregationLevel.values);
    if (disableOneMinuteResolution)
        aggregateLvlKeys = aggregateLvlKeys.slice(1);
    return (_jsx(Select, Object.assign({ title: AggregationLevel.values[selected].title, className: className }, { children: aggregateLvlKeys.map((option) => (_jsx(SelectItem, Object.assign({ onSelect: () => onSelect(option), variant: "outlined", isSelected: option === selected }, { children: AggregationLevel.values[option].title }), option))) }), void 0));
};
export default AggregationLevelFilter;
